import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export var init = createAction("".concat(actionTypePrefix, "/INIT"), function () { return ({}); });
export var initDoneAlready = createAction("".concat(actionTypePrefix, "/INIT_DONE_ALREADY"), function () { return ({}); });
export var initDone = createAction("".concat(actionTypePrefix, "/INIT_DONE"), function (result) { return ({
    result: result,
}); });
export var switchStream = createAction("".concat(actionTypePrefix, "/SWITCH_STREAM"), function (payload) { return payload; });
export var initStreamDone = createAction("".concat(actionTypePrefix, "/INIT_STREAM_DONE"), function (streamType, result) { return ({
    streamType: streamType,
    result: result,
}); });
export var streamLoadMore = createAction("".concat(actionTypePrefix, "/STREAM_LOAD_MORE"), function () { return ({}); });
export var streamLoadDone = createAction("".concat(actionTypePrefix, "/STREAM_LOAD_DONE"), function (streamType, result) { return ({
    streamType: streamType,
    result: result,
}); });
export var storeSearchData = createAction("".concat(actionTypePrefix, ".STORE_SEARCH_DATA"), function (searchType, searchQuery) { return ({ searchType: searchType, searchQuery: searchQuery }); });
//# sourceMappingURL=actionCreators.js.map